var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIonicMdCloseCircle2 = function SvgIconIonicMdCloseCircle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_ionic-md-close-circle-2_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.001,
    cy: 30,
    r: 22.4,
    fill: "#FFF0EF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA39D",
    d: "m35.687 29.841 9.215-9.215a2.608 2.608 0 0 0-3.687-3.684l.003-.002-9.215 9.215-9.215-9.215a2.608 2.608 0 0 0-3.684 3.686l-.002-.002 9.215 9.215-9.215 9.215a2.608 2.608 0 1 0 3.683 3.686l.003-.002 9.215-9.215 9.215 9.215a2.608 2.608 0 1 0 3.686-3.684l-.002-.003z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_ionic-md-close-circle-2_svg__a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.290196 0 0 0 0 0.341176 0 0 0 0 0.513726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7034_1310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7034_1310",
    result: "shape"
  })))));
};
export default SvgIconIonicMdCloseCircle2;